import React from 'react';
import { number, string, node, func, bool } from 'prop-types';
import classnames from 'classnames';

import './pill.scss';
import Icon from '../icon/icon';

const getClassName = (count, type, className) =>
    classnames(
        'pill',
        { 'pill--has-count': count > 0 },
        { 'pill--has-large-number': count > 99 },
        { 'pill--neutral': type === 'neutral' },
        { 'pill--positive': type === 'positive' },
        { 'pill--negative': type === 'negative' },
        className
    );

const Pill = ({
    title,
    count,
    type,
    children,
    dataQ,
    onClick,
    className,
    disabled,
    icon,
    iconType,
}) => {
    const Elem = onClick ? 'button' : 'div';

    return (
        <Elem
            className={getClassName(count, type, className)}
            disabled={disabled}
            onClick={onClick}
            {...(onClick && { style: { cursor: 'pointer' } })}
        >
            {icon && <Icon type={iconType} />}
            <span className="pill-title" data-q={dataQ}>
                {title}
            </span>
            {children}
            {count > 0 && <span className="pill-count">{count}</span>}
        </Elem>
    );
};

Pill.defaultProps = {
    children: undefined,
    className: undefined,
    count: null,
    dataQ: undefined,
    onClick: null,
    type: 'positive',
    disabled: false,
    icon: false,
    iconType: '',
};

Pill.propTypes = {
    children: node,
    className: string,
    count: number,
    dataQ: string,
    disabled: bool,
    icon: bool,
    iconType: string,
    onClick: func,
    title: string.isRequired,
    type: string,
};

export default Pill;
